var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{'gray-outline': _vm.withBorder},style:({width: (_vm.width + "px"), height: (_vm.height + "px") }),attrs:{"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }